import { Tag as AntTag } from 'antd';
import type { TagProps as AntTagProps } from 'antd';
import type React from 'react';

import { withAuthGuard } from '../../auth';
import type { AuthProps } from '../../auth';

export type TagProps = AntTagProps & AuthProps;

const GuardedTag = withAuthGuard(AntTag, {
    defaultFallback: 'hide',
}) as unknown as React.ForwardRefExoticComponent<TagProps & React.RefAttributes<HTMLSpanElement>>;

/**
 * Generic color + label (+ icon) atom — no domain knowledge. Extracted from
 * `web-content`'s `StatusTag`/`DifficultyTag`, which each baked a
 * `ContentStatus`/`ContentDifficulty` → color/label mapping directly into a
 * Tag render. That domain mapping stays app-side; only the rendering
 * primitive moves here.
 */
export const Tag = Object.assign(GuardedTag, {
    CheckableTag: AntTag.CheckableTag,
});
